/* unplugin-vue-components disabled */import __unplugin_components_0 from '/Users/Zhuanz/Desktop/project/oral-app/src/components/Tabbar.vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "cross-container"
};
const _hoisted_3 = {
  class: "margin-right-10"
};
const _hoisted_4 = {
  class: "float-left margin-left-10"
};
const _hoisted_5 = {
  class: "margin-right-10"
};
const _hoisted_6 = {
  class: "float-left margin-left-10"
};
import { changeStatusApi } from "@/api/shipment";
import { getListApi } from "@/api/customer";
import { showNotify } from "vant";
import womanIcon from "@/assets/icon/woman.svg";
import manIcon from "@/assets/icon/man.svg";
export default /*@__PURE__*/_defineComponent({
  __name: 'Customer',
  setup(__props) {
    const router = useRouter();
    const shipmentList = ref([]);
    const shipmentParam = ref({
      id: "",
      pageNum: 1,
      pageSize: 10,
      name: ""
    });
    const loading = ref(false);
    const finished = ref(false);
    const pages = ref(0);
    const clearSearch = () => {
      onSearch();
    };
    const onSearch = () => {
      shipmentParam.value.pageNum = 1;
      shipmentList.value = [];
      onLoad();
    };
    const onLoad = async () => {
      const res = await getListApi(shipmentParam.value);
      if (res.code === 200 && res.data?.records?.length === 0) {
        finished.value = true;
        loading.value = false;
        return false;
      }
      if (res.code === 200 && res.data?.records.length > 0) {
        if (shipmentList.value.length > 0 && res.data?.current === 1) {
          return;
        }
        shipmentList.value = shipmentList.value.concat(res.data?.records ?? []);
        loading.value = false;
        pages.value = res.data?.pages;
        shipmentParam.value.pageNum = shipmentParam.value.pageNum + 1;
      }
      if (pages.value === shipmentParam.value.pageNum) {
        finished.value = true;
      }
    };
    const onClick = item => {
      router.push("/edit/" + item.id);
    };
    const onRefresh = () => {
      finished.value = false;
      shipmentParam.value.pageNum = 1;
      loading.value = true;
      shipmentList.value = [];
      onLoad();
    };
    const changeStatus = async item => {
      console.log(item, "item");
      const res = await changeStatusApi(item.id);
      if (res.code === 200) {
        onLoad();
        showNotify({
          type: "success",
          message: res.msg
        });
      } else {
        showNotify({
          type: "danger",
          message: res.msg
        });
      }
    };
    function goToAdd() {
      console.log("goToAdd");
      router.push("/customer/add");
    }
    return (_ctx, _cache) => {
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_van_back_top = _resolveComponent("van-back-top");
      const _component_tabbar = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_search, {
        background: "#1989fa",
        onClear: clearSearch,
        modelValue: _unref(shipmentParam).name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(shipmentParam).name = $event),
        onSearch: onSearch,
        shape: "round",
        placeholder: "请输入搜索关键词"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
        type: "primary",
        modelValue: _unref(shipmentParam).name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(shipmentParam).name = $event),
        fixed: "top",
        onClick: goToAdd,
        style: {
          "width": "100%",
          "margin-top": "20px",
          "margin-bottom": "20px"
        }
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("添加患者")])),
        _: 1,
        __: [3]
      }, 8, ["modelValue"]), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(loading),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(loading) ? loading.value = $event : null),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          finished: _unref(finished),
          "finished-text": "没有更多了",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shipmentList), (item, index) => {
            return _openBlock(), _createBlock(_component_van_swipe_cell, {
              key: index
            }, {
              right: _withCtx(() => [_createVNode(_component_van_button, {
                square: "",
                type: "primary",
                text: "更改",
                onClick: $event => changeStatus(item),
                class: "delete-btn"
              }, null, 8, ["onClick"])]),
              default: _withCtx(() => [(_openBlock(), _createBlock(_component_van_cell, {
                key: index,
                title: `${item.name} | ${item.phone}`,
                "is-link": "",
                icon: "man-o",
                onClick: $event => onClick(item),
                label: `项目名称: ${item.visitTime} | 初诊日期: ${item.visitTime}`
              }, {
                icon: _withCtx(() => [_createVNode(_component_van_icon, {
                  name: item.sex === 0 ? _unref(manIcon) : _unref(womanIcon),
                  class: "custom-icon"
                }, null, 8, ["name"])]),
                label: _withCtx(() => [_createElementVNode("span", null, "初诊日期:" + _toDisplayString(item.visitTime), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_row, null, {
                  default: _withCtx(() => [_createVNode(_component_van_col, {
                    span: "12"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(item?.rightTop), 1)]),
                    _: 2
                  }, 1024), _createVNode(_component_van_col, {
                    span: "12"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(item?.leftTop), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024), _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [_createVNode(_component_van_col, {
                    span: "12"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(item?.rightBottom), 1)]),
                    _: 2
                  }, 1024), _createVNode(_component_van_col, {
                    span: "12"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(item?.leftBottom), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024)])]),
                _: 2
              }, 1032, ["title", "onClick", "label"]))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        }, 8, ["finished"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_back_top), _createVNode(_component_tabbar, {
        active: 1
      })]);
    };
  }
});